import { FunctionComponent } from 'react';

import { SuburbPageFlatmatesBrick } from './SuburbPageFlatmatesBrick';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';
import { mapDynamicContentItems } from '../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';

export const SuburbPageFlatmatesBrickWithData: FunctionComponent = () => {
  const flatmatesInsights = useSuburbPageQuery()?.data?.suburbPageBySlug?.flatmatesInsights;

  if (!flatmatesInsights) return null;

  const { title, subtitle, averageRoomRent, supplyAndDemand, footerNote } = flatmatesInsights;

  return (
    <SuburbPageFlatmatesBrick
      title={title}
      subtitle={subtitle}
      averageRoomRentSubBrick={averageRoomRent}
      supplyAndDemandSubBrick={supplyAndDemand}
      footerNote={mapDynamicContentItems(footerNote)}
    />
  );
};
